import "../playerList/index.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import AppShell from "../../components/appShell";
import ViewPlayers from "../../components/viewPlayers";
import Modal from "../../components/modal";
import {
  boughtPlayers,
  getProfile,
  activeBlock as activeBlockk,
  BiddingBlocks,
  blockStatus,
  selectbiddingBlocks,
  purseremaining as getPurse,
  selectBidderProfile,
  selectactiveBidding,
  activeBidding,
  selectActiveSession,
  getActiveSession,
  selectLoginStatus,
} from "../../store/features/bidderSlice";
import { useSocketRoom } from "../../hooks/useSocketRoom";

const AllPlayers = ({ socket }) => {
  let [key, setKey] = useState("elite");
  let biddingBlocks = useSelector(selectbiddingBlocks);
  let [showLoading, setShowLoading] = useState(false);
  let [counter, setCounter] = useState(1);
  let [content, setContent] = useState("");
  let profile = useSelector(selectBidderProfile);
  let session = useSelector(selectActiveSession);
  let activePlayer = useSelector(selectactiveBidding);
  let LoginStatus = useSelector(selectLoginStatus);
  let dispatch = useDispatch();

  // Rejoins on every reconnect, so a dropped socket recovers on its own.
  useSocketRoom(socket, { role: "bidder", id: profile?._id, sessionId: session?.sessionId });

  useEffect(() => {
    dispatch(boughtPlayers());
    dispatch(getProfile());
    dispatch(activeBidding());
    dispatch(getPurse());
    dispatch(activeBlockk());
    dispatch(BiddingBlocks());
    dispatch(getActiveSession());
    dispatch(boughtPlayers());
    dispatch(blockStatus());
  }, [counter]);

  useEffect(() => {
    if (session?.sessionId) {
      socket.on("block-started", (playerType) => {
        setContent(playerType?.toUpperCase() + " BLOCK STARTED!");
        setShowLoading(true);
        setCounter((a) => a + 1);
        setTimeout(() => {
          setShowLoading(false);
        }, 2500);
      });

      socket.on("block-paused", () => {
        setContent("BIDDING STOPPED!");
        setShowLoading(true);
        setCounter((a) => a + 1);
        setTimeout(() => {
          setShowLoading(false);
        }, 2500);
      });

      socket.on("block-finished", (playerType) => {
        setShowLoading(true);
        // console.log(playerType);
        setContent(playerType?.toUpperCase() + " BLOCK FINISHED!");
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      });

      socket.on("bid-updated", () => {
        setCounter((a) => a + 1);
      });

      socket.on("rtm-updated", () => {
        setCounter((a) => a + 1);
      });

      socket.on("set-player-unsold", () => {
        setContent(
          <div className="call">
            <span className="call-verdict danger">Unsold</span>
          </div>
        );
        setShowLoading(true);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        setCounter((a) => a + 1);
      });

      socket.on("set-player-sold", () => {
        // console.log(activePlayer);
        setShowLoading(true);
        setContent(
          <div className="call">
            <span className="call-verdict success">Sold</span>
            <span className="call-team">{activePlayer?.lastBidBy?.team}</span>
          </div>
        );
        setTimeout(() => {
          window.location.reload();
        }, 5000);
      });
    }
  }, [session?.sessionId]);


  if (LoginStatus === "waiting") {
    return (
      <div className="bid-loading">
        <CircularProgress sx={{ color: "#0040a8" }} />
      </div>
    );
  }

  if (LoginStatus === "failed") {
    return (
      <AppShell role="public">
        <h1 className="au-heading">Not signed in</h1>
        <p className="au-subheading">
          <Link to="/bidder/login">Sign in as a bidder</Link> to see the pool.
        </p>
        <Navigate to="/bidder/login" replace />
      </AppShell>
    );
  }

  return (
    <AppShell role="bidder">
      <Modal show={showLoading} content={content} />

      <div className="player-list">
        <header className="player-list-head">
          <div>
            <h1 className="au-heading">Auction Pool</h1>
            <p className="au-subheading">
              Every player up for auction, and what they went for.
            </p>
          </div>
        </header>

        <ViewPlayers blocks={biddingBlocks} keyState={{ key, setKey }} />
      </div>
    </AppShell>
  );
};

export default AllPlayers;
